<template>
  <section
    class="c-illustration-container"
  > 
    <transition
      v-if="illustrationIds[0] === false"
      name="building-fade"
      mode="out-in"
    >
      <MissingImage>Bilde mangler</MissingImage>
    </transition>
    <transition
      v-else
      name="building-fade"
      mode="out-in"
    >
      <selector-illustration
        v-if="activeIllustrationId"
        :illustrationId="activeIllustrationId"
      />
    </transition>
    <illustration-navigation
      v-if="illustrationIds.length > 1"
      :illustrationIds="illustrationIds"
    />
    <selector-thumbnails
      v-if="illustrationIds.length > 1"
      :illustrationIds="illustrationIds"
    />
  </section>
</template>

<script>
// Data models
import Building from '@/models/Building';
import Illustration from '@/models/Illustration';
import Selector from '@/models/Selector';

// UI Components
import IllustrationNavigation from '@/components/IllustrationNavigation.vue';
import SelectorIllustration from '@/components/SelectorIllustration.vue';
import SelectorThumbnails from '@/components/SelectorThumbnails.vue';
import MissingImage from '@/components/MissingImage.vue';

export default {
  name: 'ResidenceIllustration',
  components: {
    IllustrationNavigation,
    SelectorIllustration,
    SelectorThumbnails,
    MissingImage,
  },
  computed: {
    selector() {
      return Selector.query()
        .with('buildings')
        .first();
    },
    currentSection() {
      return this.$store.state.entities.illustrations.currentSection;
    },
    sectionIllustrations() {
      return Illustration.getSection(this.$store.state.entities.illustrations.currentSection, this.selector);
    },
    building() {
      if (this.selectedBuilding === 'all') {
        return false;
      } else {
        return Building.find(this.selectedBuilding);
      }
    },
    activeIllustrationId() {
      return this.$store.state.entities.illustrations.activeIllustration;
    },
    selectedBuilding() {
      return this.$store.state.entities.buildings.selectedBuilding;
    },
    illustrationIds() {
      if (this.selectedBuilding === 'all') {
        return this.selector.overview_illustration_ids;
      } else {
        return this.selector.building_illustration_ids[this.building.id];
      }
    },
  },
  watch: {
    currentSection() {
      this.setActiveIllustration();
    },
    illustrationIds() {
      this.setSectionIds();
    },
  },
  mounted() {
    this.setActiveIllustration();
    this.setSectionIds();
  },
  methods: {
    setActiveIllustration() {
      if (this.sectionIllustrations[0]) {
        Illustration.commit(state => {
          state.activeIllustration = this.sectionIllustrations[0].id;
        });
      }
    },
    setSectionIds() {
      Illustration.commit(state => {
        state.sectionIds = this.illustrationIds;
      });
    },
  },
};
</script>
